<template>
  <div>
    <a-alert
      :message="$t('bulletin.duplicationHappened')"
      type="info"
      show-icon
      v-if="cloneAlert"
    />
    <div class="row">
      <div class="col-md-4">
        <a-select
          size="large"
          class="w-100"
          :value="selectedBtType"
          @change="selectedBtType = $event"
        >
          <a-select-option
            v-for="(value, key) in builletinTypesNames"
            :key="key"
            :value="key"
          >
            {{ value }}</a-select-option
          >
        </a-select>
      </div>
      <div class="col-md-3 d-flex">
        <label class="pr-2 pt-2">{{ $t("etablissement.niveau") }}</label>
        <a-select
          size="large"
          class="w-100"
          :value="levelSelected"
          @change="levelSelected = $event"
        >
          <a-select-option
            v-for="(value, name, index) in levelSelectData"
            :key="index"
            :value="name"
          >
            {{ value }}</a-select-option
          >
        </a-select>
      </div>

      <div class="col-md-2 d-flex">
        <label class="mr-2 mt-2">{{ $t("emploi.trimestre") }}</label>

        <a-select
          size="large"
          class="w-50"
          :placeholder="$t('paiement.selectionnerMois')"
          :value="selectedTrimester"
          @change="selectedTrimester = $event"
          default-value="1"
        >
          <a-select-option
            v-for="(value, index) in ['1', '2', '3']"
            :key="index"
            :value="value"
          >
            {{ value }}</a-select-option
          >
        </a-select>
      </div>
      <div class="col-md-3">
        <a-button
          type="primary"
          class="mx-auto my-2"
          @click="visibleClone = true"
          :disabled="isReadOnly"
          style="width: 100%"
        >
          {{ $t("bulletin.duplicateSettings") }}
        </a-button>
      </div>
    </div>
    <params-clone
      :visible="visibleClone"
      :levels="levelSelectData"
      :builletinTypesNames="builletinTypesNames"
      @hide="hideClone"
      @cloneHappened="cloneHappened"
    />
    <peda
      v-if="selectedBtType == 'MP'"
      :affichageData="affichageData"
      :loading="loading"
      :templateList="templateList"
      :certifParams="specCertifParams"
      :students="students"
      :studentsKey="studentsKey"
      @update:affichageData="updateAffichageData"
    />
    <spec
      v-else
      :affichageData="affichageData"
      :loading="loading"
      :templateList="templateList"
      :certifParams="specCertifParams"
      :students="students"
      :studentsKey="studentsKey"
      @discard="restoreToDefault"
      @saveData="saveData"
      @selectTemplate="selectTemplate"
    />
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import cloneDeep from "lodash/cloneDeep";
import { mapState, mapGetters } from "vuex";
import { getLevels, getDefaultLevel } from "@/config/LevelConstants";
import spec from "./spec.vue";
import peda from "./peda.vue";
import ParamsClone from "./ParamsClone.vue";
import templates from "@/views/bulletinv2/studentMarks/scripts/bulletinHeplers/templates/index.js";
export default {
  name: "BulletinBuilder",
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.displaySettings;
      return value === "ro";
    },
    combinedSelection() {
      return [this.levelSelected, this.selectedTrimester, this.selectedBtType];
    },
    studentSelection() {
      return [this.levelSelected, this.selectedBtType];
    },
  },
  components: {
    spec,
    peda,
    ParamsClone,
  },
  data() {
    return {
      cloneAlert: false,
      visibleClone: false,
      schoolType: null,
      affichageData: {
        type: "MS",
        colorPalette: {
          main: "#40bbef",
          mainBorder: "#f0f5f7",
          secondary: "#e0edf3",
          secondaryBorder: "#40bbef",
          tertiary: "#e1e1e2",
          tertiaryBorder: "#40bbef",
          normal: {
            moy: "#433e3f",
            rank: "#433e3f",
            min: "#433e3f",
            max: "#433e3f",
          },
          peda: {
            moy: "#433e3f",
            rank: "#433e3f",
            min: "#433e3f",
            max: "#433e3f",
          },
          personalized: {
            moy: "#433e3f",
            rank: "#433e3f",
            min: "#433e3f",
            max: "#433e3f",
          },
        },
        bg_image: null,
        qrCode: null,
        pedaLike: false,
        headers: {
          schoolName: true,
          birthDate: true,
          schoolarYear: true,
          studentName: true,
          className: true,
          nbInscription: true,
          uniqueIden: true,
          govText: false,
          schoolLogo: true,
          trimHeader: "الثلاثي",
          studentImage: null,
          govLogo: null,
          qrCode: null,
          customGovLogo: null,
        },
        body: {
          fuseSubjects: false,
          hideSubjects: false,
          hideMinPerClass: false,
          hideMaxPerClass: false,
          hideSubModuleMark: false,
          hideModuleMark:false,
          hideSubjectMark:false,
          subsubjectMark: {
            auto: true,
          },
          subjectMark: {
            auto: true,
          },
          moduleMark: {
            auto: true,
          },
          appreciation: {
            auto: true,
          },
          minPerClass: {
            auto: true,
          },
          maxPerClass: {
            auto: true,
          },
        },
        side: {
          stamp: true,
          printDate: true,
          adminAppreciation: false,
          certifUsePersonalizedMoy: false,
          normal: {
            allow: true,
            min: true,
            max: true,
            rank: false,
            name: "معدل",
          },
          peda: {
            allow: true,
            min: false,
            max: false,
            rank: false,
            name: "معدل الثلاثي",
          },
          personalized: {
            allow: false,
            min: false,
            max: false,
            rank: false,
            name: "معدل الخاص بمدرسة اد تراست",
            coefMoy: 1,
            coefPeda: 1,
          },
          certif: true,
        },
        spacing: {
          forceOnePage: false, //Not implimented
          stretchFullPage: false, //Not implimented
          squeezeToNLines: 0, //Not implimented
          margin: 12,
          bottomLimit: 5,
          trimersterLineMargin: 0,
        },
        options: {
          logosPosition: {
            //"c": center, "l": left, "c": center
            schoolLogo: ["c", 0],
            //studentImage: ["c", 0],
            //govLogo: ["c", 0],
          },
          headerFonts: {
            "*": {
              title: {
                font: "Amiri",
                style: "normal",
                color: "#000000",
                size: 12,
              },
              lineReturn: false,
              value: {
                font: "Amiri",
                style: "normal",
                color: "#000000",
                size: 12,
              },
            },
          },
          headersPositions: {
            //"c": center, "l": left, "c": center, "b": bellow the trimester line,
            schoolName: ["r", 0],
            studentName: ["r", 1],
            birthDate: ["r", 2],
            uniqueIden: ["r", 3],
            schoolarYear: ["l", 0],
            className: ["l", 1],
            nbInscription: ["l", 2],
          },
          imageScalers: {
            schoolLogo: 1,
            studentImage: 1,
            govLogo: 1,
            qrCode: 1,
          },
        },
      },
      previousAffichageData: {},
      defaultAffichageData: {},
      students: {},
      configList: [],
      levelSelected: 1,
      selectedTrimester: "1",
      selectedBtType: "MS",
      builletinTypesNames: {
        MP: this.$t("bulletin.bulletinPedagogique"),
        MT: this.$t("bulletin.bulletinSpecifique"),
        MS: this.$t("bulletin.bulletinVerySpecifique"),
      },
      templateList: [],
      loading: true,
      studentsKey: 1,
      specCertifParams: [],
      pedaCertifParams: [],
    };
  },
  async created() {
    console.clear();
    this.schoolType = this.activeBuilding.type;
    this.loading = true;
    this.levelSelected = getDefaultLevel(this.schoolType, this.countryCode);
    // getting certifs
    await Promise.allSettled([
      apiClient
        .get("/certification/MP")
        .then((res) => {
          this.pedaCertifParams = res.data;
        })
        .catch((e) => {
          console.log(e);
        }),
      apiClient
        .get("/certification/MS")
        .then((res) => {
          this.specCertifParams = res.data;
        })
        .catch((e) => {
          console.log(e);
        }),
    ]);
    this.templateList = Object.values(templates || []);
    const defaultTemplate = this.templateList.find(
      (t) => t.templateKey == "default"
    );
    this.previousAffichageData = cloneDeep(
      defaultTemplate || this.affichageData
    );
    this.defaultAffichageData = cloneDeep(
      defaultTemplate || this.affichageData
    );
    delete this.defaultAffichageData.templateName;
    delete this.defaultAffichageData.templateKey;
    await this.getParam();
    await this.loadStudents();
    this.loading = false;
  },
  watch: {
    async combinedSelection() {
      await this.getParam();
    },
    async studentSelection() {
      await this.loadStudents();
    },
  },
  methods: {
    loadStudents: async function () {
      const sy = this.settings.activeSchoolarYear;
      let classRooms;
      await apiClient
        .post("/classrooms/filter", {
          query: {
            status: "active",
            level: Number(this.levelSelected),
          },
          aggregation: {
            $project: {
              _id: 1,
            },
          },
        })
        .then((res) => (classRooms = res.data))
        .catch((e) => this.$message.error(this.$t("error.noClassFound")));
      if (!classRooms || !classRooms.length) {
        this.$message.error(this.$t("error.noClassFound"));
        this.students = {};
        this.studentsKey++;
        return;
      }
      let match = {};
      match[`schoolarYearsHistory.${sy}`] = {
        $in: classRooms.map((c) => c._id),
      };
      const studentsAggregation = [
        {
          $match: match,
        },
        {
          $set: {
            classRoom: {
              $convert: {
                input: "$schoolarYearsHistory." + sy,
                to: "objectId",
                onError: null,
                onNull: null,
              },
            },
          },
        },
        {
          $lookup: {
            from: "classrooms",
            localField: "classRoom",
            foreignField: "_id",
            as: "classRoom",
          },
        },
        {
          $unwind: { path: "$classRoom" },
        },
        {
          $project: {
            _id: 1,
            firstName: 1,
            lastName: 1,
            middleName: 1,
            lastName: 1,
            BirthDate: 1,
            numberOfRegistrations: "$personalInfo.numberOfRegistrations",
            classRoom: "$classRoom.name",
            classRoomID: "$classRoom._id",
            photo: 1,
          },
        },
      ];
      await apiClient
        .post("/students/filter", {
          query: {
            status: "active",
          },
          aggregation: studentsAggregation,
        })
        .then(({ data }) => {
          this.students = data.reduce((acc, student) => {
            const id = student.classRoomID;

            if (!acc[id]) {
              acc[id] = {
                classRoomID: id,
                classRoom: student.classRoom, // add name at top level
                students: [],
              };
            }

            acc[id].students.push(student);
            return acc;
          }, {});
        })
        .catch((e) => this.$message.error(this.$t("error.noStudentFound")))
        .finally(() => this.studentsKey++);
    },
    async getParam() {
      await apiClient
        .post("/bulletin/v2/affichage/list", {
          status: "active",
          isTemplate: false,
          level: Number(this.levelSelected),
          trimester: Number(this.selectedTrimester),
          schoolarYear: String(this.settings.activeSchoolarYear),
          type: String(this.selectedBtType),
        })
        .then(({ data }) => {
          if (data.length > 0) {
            const existingConfig = data[0];
            this.affichageData = cloneDeep(existingConfig);
            this.previousAffichageData = cloneDeep(existingConfig);
            if (this.selectedBtType == "MP") {
              this.affichageData.body = {
                hideSubModuleMark: this.affichageData.body?.hideSubModuleMark,
              };
              this.previousAffichageData.body = {
                hideSubModuleMark: this.affichageData.body?.hideSubModuleMark,
              };
            }
          } else {
            this.affichageData = cloneDeep(this.defaultAffichageData);
            this.previousAffichageData = cloneDeep(this.defaultAffichageData);
          }
          this.affichageData.schoolarYear = this.settings.activeSchoolarYear;
          this.affichageData.type = this.selectedBtType;
          this.affichageData.level = this.levelSelected;
          this.affichageData.trimester = this.selectedTrimester;
          // EDWEB-3235: added image scalers, set to default values to avoid data integrity issues
          if (!this.affichageData?.options?.imageScalers) {
            this.affichageData.options.imageScalers = {
              schoolLogo: 1,
              studentImage: 1,
              govLogo: 1,
              qrCode: 1,
              stamp: 1,
            };
          }
        });
    },
    restoreToDefault() {
      this.affichageData = cloneDeep(this.previousAffichageData);
    },
    saveData(data) {
      if (data.__v) delete data.__v;
      if (data.updatedAt) delete data.updatedAt;
      if (data.createdAt) delete data.createdAt;
      this.affichageData = data;
      this.previousAffichageData = cloneDeep(data);
    },
    updateAffichageData(data) {
      if (data.__v) delete data.__v;
      if (data.updatedAt) delete data.updatedAt;
      if (data.createdAt) delete data.createdAt;
      if (data._id) this.affichageData._id = data._id;
      this.affichageData.headers.uniqueIden = data.headers?.uniqueIden;
      this.affichageData.headers.nbInscription = data.headers?.nbInscription;
      this.affichageData.headers.birthDate = data.headers?.birthDate;
      this.affichageData.side.stamp = data.side?.stamp;
      this.affichageData.side.printDate = data.side?.printDate;
      this.affichageData.body.hideSubModuleMark = data.body?.hideSubModuleMark;
    },
    selectTemplate(templateID) {
      const template = this.templateList.find(
        (t) => t.templateKey == templateID
      );
      if (template) {
        let oldId;
        if (this.affichageData._id) oldId = this.affichageData._id;
        let newAffichageData = cloneDeep(template);
        newAffichageData.usedTemplate = templateID;
        newAffichageData._id = oldId;
        delete newAffichageData.templateName;
        delete newAffichageData.templateKey;
        newAffichageData.schoolarYear = this.settings.activeSchoolarYear;
        newAffichageData.type = this.selectedBtType;
        newAffichageData.level = this.levelSelected;
        newAffichageData.trimester = this.selectedTrimester;
        this.affichageData = newAffichageData;
      }
    },
    hideClone() {
      this.visibleClone = false;
    },
    cloneHappened() {
      this.visibleClone = false;
      this.cloneAlert = true;
    },
  },
};
</script>
